/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAppDevice } from '../models/work-app-device';
import { WorkAppDeviceResponseDto } from '../models/work-app-device-response-dto';
import { WorkCreateAppDeviceDto } from '../models/work-create-app-device-dto';

@Injectable({ providedIn: 'root' })
export class WorkAppDevicesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appDevicesV2ControllerFindByUserId()` */
  static readonly AppDevicesV2ControllerFindByUserIdPath = '/v2/app-devices/byUserId/{userId}';

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appDevicesV2ControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  appDevicesV2ControllerFindByUserId$Response(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAppDevice>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAppDevicesV2Service.AppDevicesV2ControllerFindByUserIdPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAppDevice>>;
      })
    );
  }

  /**
   * Required permissions: users:read, users:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appDevicesV2ControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appDevicesV2ControllerFindByUserId(
    params: {
      userId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkAppDevice>> {
    return this.appDevicesV2ControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAppDevice>>): Array<WorkAppDevice> => r.body)
    );
  }

  /** Path part for operation `appDevicesV2ControllerFindByContactId()` */
  static readonly AppDevicesV2ControllerFindByContactIdPath = '/v2/app-devices/byContactId/{contactId}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appDevicesV2ControllerFindByContactId()` instead.
   *
   * This method doesn't expect any request body.
   */
  appDevicesV2ControllerFindByContactId$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAppDevice>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAppDevicesV2Service.AppDevicesV2ControllerFindByContactIdPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAppDevice>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appDevicesV2ControllerFindByContactId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appDevicesV2ControllerFindByContactId(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkAppDevice>> {
    return this.appDevicesV2ControllerFindByContactId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAppDevice>>): Array<WorkAppDevice> => r.body)
    );
  }

  /** Path part for operation `appDevicesV2ControllerRegisterOrUpdate()` */
  static readonly AppDevicesV2ControllerRegisterOrUpdatePath = '/v2/app-devices';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appDevicesV2ControllerRegisterOrUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appDevicesV2ControllerRegisterOrUpdate$Response(
    params: {
      body: WorkCreateAppDeviceDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAppDeviceResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAppDevicesV2Service.AppDevicesV2ControllerRegisterOrUpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAppDeviceResponseDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appDevicesV2ControllerRegisterOrUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appDevicesV2ControllerRegisterOrUpdate(
    params: {
      body: WorkCreateAppDeviceDto
    },
    context?: HttpContext
  ): Observable<WorkAppDeviceResponseDto> {
    return this.appDevicesV2ControllerRegisterOrUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAppDeviceResponseDto>): WorkAppDeviceResponseDto => r.body)
    );
  }

}
